<script setup>
const userStore = useUserStore();

const baseTheme = ref(userStore.getBaseAccent ?? '#ff5c00');

watch(
    () => userStore.getBaseAccent,
    (newVal) => {
        if (newVal) {
            baseTheme.value = newVal;
        }
    },
    {
        immediate: true,
    },
);

const theme = computed(() => {
    const baseShades = generateShades(baseTheme.value);

    return {
        '--brand-primary': adjustColor(baseTheme.value, 0),
        '--brand-primary-dark': baseShades.darker[0],
        '--brand-primary-light': baseShades.lighter[0],
    };
});

const updateTheme = () => {
    const body = document.querySelector('body');
    if (body) {
        Object.entries(theme.value).forEach(([key, value]) => {
            body.style.setProperty(key, value);
        });
    }
};

// get body tag and set the theme whenever baseTheme or inputTheme changes
watch(baseTheme, updateTheme, {
    immediate: true,
});

function adjustColor(hex, factor) {
    let r = parseInt(hex.slice(1, 3), 16);
    let g = parseInt(hex.slice(3, 5), 16);
    let b = parseInt(hex.slice(5, 7), 16);

    r = Math.min(255, Math.max(0, r + factor));
    g = Math.min(255, Math.max(0, g + factor));
    b = Math.min(255, Math.max(0, b + factor));

    return `${r} ${g} ${b}`;
}

function generateShades(hex) {
    const shades = {
        lighter: [],
        darker: [],
    };

    for (let i = 1; i <= 3; i++) {
        const factor = i * 15; // Adjust this value to change the intensity of the shades
        shades.lighter.push(adjustColor(hex, factor));
        shades.darker.push(adjustColor(hex, -factor));
    }

    return shades;
}
</script>
